import {InputTypes} from "../InputTypes";

export const Doctor = Object.freeze({
    _id: {
        visibleName: "Id",
        hidden: true,
        type: InputTypes.TEXT,
    },
    name: {
        visibleName: "Nombre",
        type: InputTypes.TEXT,
    },
    last_name: {
        visibleName: "Apellido",
        type: InputTypes.TEXT,
    },
    email: {
        visibleName: "Email",
        type: InputTypes.EMAIL,
    },
    password: {
        visibleName: "Contraseña",
        hidden: true,
        pattern: ".{7,}",
        title: "Introduce una contraseña de más de 6 caracteres",
        type: InputTypes.PASSWORD,
    },
    passwordVerification: {
        visibleName: "Repetir contraseña",
        hidden: true,
        type: InputTypes.PASSWORD,
    },
    telephone_number: {
        visibleName: "Teléfono",
        type: InputTypes.TELEPHONE_NUMBER,
    },
    prefix: {
        visibleName: "Prefijo",
        hidden: true,
        type: InputTypes.TEXT,
    },
    nif: {
        visibleName: "NIF",
        hidden: true,
        type: InputTypes.TEXT,
    },
    timestamp: {
        visibleName: "Fecha de creación",
        nonEditable: true,
        type: InputTypes.DATE,
    },
    speciality: {
        visibleName: "Especialidad",
        type: InputTypes.TEXT,
    },
    formation: {
        visibleName: "Formación",
        hidden: true,
        type: InputTypes.TEXT_AREA,
    },
    description: {
        visibleName: "Descripción",
        hidden: true,
        type: InputTypes.TEXT_AREA,
    },
    direction: {
        visibleName: "Dirección",
        type: InputTypes.TEXT,
    },
    direction_facturation: {
        visibleName: "Dirección de Facturación",
        type: InputTypes.TEXT,
    },
    toString: "Doctor"
})